export default "__VITE_ASSET__BlXJIig0__"